import { createContext, useContext, useState, useCallback } from 'react'

const LAUNCH_PASSWORD = 'Contrib#2026'
const STORAGE_KEY = 'pt-launch-auth'

const AuthContext = createContext({ isContributor: false, login: () => {}, logout: () => {} })

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [isContributor, setIsContributor] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === 'true'
  )

  const login = useCallback((password) => {
    if (password === LAUNCH_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true')
      setIsContributor(true)
      return true
    }
    return false
  }, [])

  const logout = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY)
    setIsContributor(false)
  }, [])

  return (
    <AuthContext.Provider value={{ isContributor, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

const ProtectedRoute = ({ children }) => {
  const { isContributor, login } = useAuth()
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!login(password)) {
      setError(true)
      setPassword('')
    }
  }

  if (isContributor) return children

  return (
    <div className="min-h-screen bg-charcoal flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="text-4xl mb-4 font-bold bg-gradient-to-r from-cyan to-purple bg-clip-text text-transparent">
            Contributor Access
          </div>
          <p className="text-gray-400 text-lg">This page is restricted to contributors.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(false) }}
            placeholder="Enter contributor password"
            autoFocus
            className="w-full px-4 py-3 rounded-lg bg-slate border border-gray-600 text-off-white placeholder-gray-500 focus:outline-none focus:border-cyan transition-colors"
          />
          {error && (
            <p className="text-red-400 text-sm">Incorrect password. Try again.</p>
          )}
          <button
            type="submit"
            className="w-full px-4 py-3 rounded-lg bg-gradient-to-r from-cyan to-purple text-charcoal font-bold hover:opacity-90 transition-opacity"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  )
}

export default ProtectedRoute
